import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconPlus = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z" }) }));
const Memo = memo(SvgIconPlus);
export default Memo;
//# sourceMappingURL=IconPlus.js.map